import { validateProps } from '../utils';
export const isValidMetrics = metrics => validateProps(metrics, ['clientsReachedOut', 'tasksBeingHandled', 'recurringVisitsBooked', 'clientReachedOutViaLink', 'recurringSchedulesCreated']);
//# sourceMappingURL=Metrics.js.map